import React from 'react'
import {Routes,Route,} from "react-router-dom";
import Legal from './components/Legal';
import About from './components/About';
import Support from './components/Support';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Erro404 from './components/Erro404';
import CategoryMenu from './components/CategoryMenu';
import SingIn from './components/SingIn';
import AddBusiness from './components/AddBusiness';
import AddEvent from './components/AddEvent'
import Parse from 'parse/dist/parse.min.js';
Parse.initialize('iMDjJAPDYIcx09KO3DIiD9MbhayTDY9i3dpmFrnC', 'KopEJkmcTTGlg3XYVJfVavf92dOmD2ORjGWme7VO')
Parse.serverURL = 'https://parseapi.back4app.com/'

export default function App() {



  return (
     <>
     <Navbar/>
    <Routes>
      <Route path="/" element={<About/>}/> 
      <Route path="/legal/" element={<Legal/>}/> 
      <Route path="/support/" element={<Support/>}/> 
      <Route path="/sing-in/" element={<SingIn/>}/> 
      <Route path="/add-business/" element={<AddBusiness/>}/>
      <Route path="/category-business/" element={<CategoryMenu/>}/>
      <Route path="/events/" element={<AddEvent/>}/>
      <Route path="*" element={<Erro404/>}/>      
    </Routes>
    <Footer/>   
    </>  
  )
}

